import {
// actions
    ADD_FIELD
   ,INSERT_FIELDS
   ,DELETE_FIELD
// reducer names
   ,FORM_TEMPLATE
} from './../constants'

const initialState = {
}

export default (state = initialState, action) => {
    const key = action.payload.key;
    if( !Array.isArray( state ) ) return state;
    switch (action.type) {

        case FORM_TEMPLATE + ADD_FIELD:
            return key === null ? state.concat( false ) : state.toSpliced( key, 0, false );
            
        case FORM_TEMPLATE + INSERT_FIELDS:
            const start = key === null ? state.length : key;
            const fields = action.payload.fields.map( i => false );
            // вставить скопированные поля перед текущим полем
            state.splice( start, 0, ...fields );
            return state;
            
        case FORM_TEMPLATE + DELETE_FIELD:
            return state.filter( (item, idx) => idx !== key );
            
        default:
            return state;
    }
}
